import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form} from 'react-bootstrap';
import { verifyConfirmationCode } from '../../utils/cognito-api.js';
import { ERROR_MESSAGES, CODE_MISTMATCHED_ERROR } from '../../data/ConfirmCodeConstants.js';
import { Header } from '../header/header.js';
import { useTranslation } from 'react-i18next';
import {rememberPin} from '../rememberPin/rememberPin.js';
import { FiMail } from 'react-icons/fi';
import { AUTH_STATE_PASS } from '../../data/GlobalConstants.js';


function ConfirmCode(props) {
    const [code, setCode] = useState('');
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const [messageStyle, setMessageStyle] = useState('');
    const [touched, setTouched] = useState({});
    const navigate = useNavigate();
    const [lenguage, setLanguage] = useState('es');
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const status = queryParams.get('status');

    const onChangeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);
    };

    const handleCodeConfirmation = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const email = queryParams.get('email');
        const userId = queryParams.get('id');
        const forgotPass = queryParams.get('forgotpass');

        if(forgotPass){
            navigate(`/forgotpin?token=${token}`, {state: AUTH_STATE_PASS })
        }
        else {
            const pinStatus = await rememberPin(email, userId)
            if(pinStatus.success === true){
                // Redirect to the about page
                navigate(`/?codeConfirmation=true&email=${email}&token=${token}&status=sended`);
            } else {
                setMessage(pinStatus.message)
            }
        }
    };

    const handleBlur = (field, value) => {
        if(value){
            setTouched((prevTouched) => ({...prevTouched, [field]: true }));
        }
    };

    const handleCodeChange = (e) => {
        const inputValue = e.target.value;
        const digitsOnly = /^\d*$/; // Regular expression to match digits only

        if (digitsOnly.test(inputValue)) {
            setCode(inputValue);
        }
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const newErrors = {};

            if (!code.trim()) {
                newErrors.code = ERROR_MESSAGES.emptyCode;
            } else {
                delete newErrors.code;
                setErrors(newErrors);
            }

            if (Object.keys(newErrors).length > 0) {
                console.log(Object.keys(newErrors).length)
                setErrors(newErrors);
            } else {
                setIsLoading(true);
                const queryParams = new URLSearchParams(window.location.search);
                const email = queryParams.get('email');

                const verified = await verifyConfirmationCode(email, code);
                if(verified){
                    setIsLoading(false);
                    await handleCodeConfirmation();
                }else{
                    setIsLoading(false);
                    setMessageStyle('errorPin');
                    setMessage(CODE_MISTMATCHED_ERROR);
                }

            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleEmailNotFound = () => {
        setMessageStyle('errorPin');
        setMessage(t('emailNotFound'));
        navigate(`/forgotpin?token=${token}`, {state: AUTH_STATE_PASS })
    }


    return (
        <Container fluid>
            <Header setLanguage={onChangeLanguage} />
            <Row className="px-4 my-5 formLogin">
                <Col sm={4} className="resize">
                    <Form onSubmit={handleSubmit}>
                        <h1>{t('h1Verify')}</h1>
                        {status && !message && <div className="errorPin mb-3">{t('emailNotFound')} <FiMail/></div>}
                        {message && <div className={messageStyle}>{t('codeMismatched')}</div>}
                            {/* <Form.Group className="mb-5 mt-5 position-relative" controlId="formBasicText">
                                <Form.Label className="fit">{t('inputCode')}</Form.Label>
                                <Form.Control
                                    name="code"
                                    type="text"
                                    className="aditionalInfo"
                                    placeholder={t('placeholderCode')}
                                    value={code}
                                    onBlur={(e) => handleBlur('code', e.target.value)}
                                    onChange={(e) => handleCodeChange(e)}
                                    isInvalid={errors.code}
                                />
                                <Form.Control.Feedback className="error" type="invalid" tooltip>{t('emptyField')}</Form.Control.Feedback>
                            </Form.Group>
                        <button className="btnLogin" type="submit" onClick={handleSubmit}>{t('btnCode')}</button> */}
                        {status && !message && <button className="btnLogin" type="submit" onClick={handleEmailNotFound}>{t('btnBack')}</button>}
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default ConfirmCode;